export const AUTH_ERROR_MESSAGES = {
  INVALID_CREDENTIALS:
    'メールアドレスまたはパスワードが正しくありません。入力内容をご確認ください。',
  ACCOUNT_LOCKED:
    'このアカウントはロックされています。管理者またはサポートにお問い合わせください。',
  TIMEOUT: 'ログイン処理がタイムアウトしました。再度お試しください。',
  NETWORK_ERROR: 'ネットワークに接続できません。接続状況をご確認の上、再度お試しください。',
  SERVER_ERROR:
    'ログイン処理中にエラーが発生しました。しばらく時間をおいてから再度お試しください。',
} as const;

export const HTTP_STATUS_AUTH_ERROR_MAP: Readonly<Record<number, string>> = {
  401: AUTH_ERROR_MESSAGES.INVALID_CREDENTIALS,
  422: AUTH_ERROR_MESSAGES.INVALID_CREDENTIALS,
  403: AUTH_ERROR_MESSAGES.ACCOUNT_LOCKED,
  408: AUTH_ERROR_MESSAGES.TIMEOUT,
  504: AUTH_ERROR_MESSAGES.TIMEOUT,
  0: AUTH_ERROR_MESSAGES.NETWORK_ERROR,
};

export function getAuthErrorMessage(status: number | null | undefined): string {
  if (status !== null && status !== undefined && status in HTTP_STATUS_AUTH_ERROR_MAP) {
    return HTTP_STATUS_AUTH_ERROR_MAP[status];
  }
  return AUTH_ERROR_MESSAGES.SERVER_ERROR;
}
